import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useContext, useState} from "react";
import {
    faPencil,
    faTrash
} from "@fortawesome/free-solid-svg-icons";

import "../styles/TemplateLegendItemElement.css";
import axios from "axios";
import Button from "./Button";
import Modal from "./Modal";
import {ColumnGrid, GridRow} from "./ColumnGrid";
import TextInput from "./TextInput";
import {ContextMenu, ContextMenuItem} from "./ContextMenu";
import {TemplateContext} from "../pages/MapTemplateEditor";
import config from '../config.json';
import _ from 'lodash';

const LocalContextMenuItem = ({icon, name, keystroke, onClick }) => {
    return (
        <ContextMenuItem onClick={onClick}>
            <ColumnGrid columns={"30px 1fr 1fr"}>
                <GridRow>
                    <FontAwesomeIcon icon={icon} style={{ margin: "auto" }}/>
                    <span>{name}</span>
                    <span style={{ textAlign: "right", fontWeight: 800 }}>{keystroke}</span>
                </GridRow>
            </ColumnGrid>
        </ContextMenuItem>
    );
}

const EditModal = ({ showModal, setShowModal, item }) => {
    const { template, setTemplate } = useContext(TemplateContext);
    const [ name, setName ] = useState();
    const [ color, setColor ] = useState();
    const [ hidden, setHidden ] = useState();

    const update = async () => {
        setShowModal(false);

        item.name = name;
        item.color = color;
        item.hidden = hidden;

        setTemplate(template);
    };

    const footer = (
        <div style={{ display: "flex", gap: "20px" }}>
            <Button color="#40b319" onClick={update} content="Update"/>
            <Button color="#c20a0a" onClick={() => setShowModal(false)} content="Cancel"/>
        </div>
    );

    return (
        <>
            <Modal
                header="Edit Legend Item"
                footer={footer}
                show={showModal}
                onClose={() => setShowModal(false)}>
                <ColumnGrid columns="1fr 1fr">
                    <GridRow>
                        <span>Name</span>
                        <TextInput onChange={e => setName(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <span>Color</span>
                        <input type="color" onChange={e => setColor(e.target.value)}/>
                    </GridRow>
                    <GridRow>
                        <span>Hidden</span>
                        <div>
                            <input type="checkbox" onChange={e => setHidden(e.target.value === 'on')} style={{ margin: 0, height: '2em', width: '2em' }}/>
                        </div>
                    </GridRow>
                </ColumnGrid>
            </Modal>
        </>
    );
}

const executeDelete = (item, template, setTemplate) => {
    const modifiedTemplate = _.cloneDeep(template);

    const index = modifiedTemplate.legend.indexOf(item);

    modifiedTemplate.legend.splice(index, 1);

    setTemplate(modifiedTemplate);
}

const TemplateLegendItemElement = ({ item }) => {
    const [ showEditModal, setShowEditModal ] = useState(false);

    const [ showContextMenu, setShowContextMenu ] = useState(false);

    const { template, setTemplate } = useContext(TemplateContext);

    return (
        <>
            <div className="LegendItemElement">
                <EditModal setShowModal={setShowEditModal} showModal={showEditModal} item={item}/>

                <ContextMenu show={showContextMenu} setShow={setShowContextMenu}>
                    <LocalContextMenuItem icon={faPencil} name="Edit" keystroke={"E"} onClick={() => {setShowContextMenu(false); setShowEditModal(true)}}/>
                    <LocalContextMenuItem icon={faTrash} name="Delete" keystroke={"⌫"} onClick={() => executeDelete(item, template, setTemplate)}/>
                </ContextMenu>

                <div className="self" tabIndex={0}
                     onContextMenu={e => {setShowContextMenu({ x: e.nativeEvent.clientX, y: e.nativeEvent.clientY }); e.preventDefault();}}
                     onKeyUp={e => {
                         e.stopPropagation();
                         e.preventDefault();
                         setShowContextMenu(false);

                         console.log(e.key);

                         if (e.key === 'e') setShowEditModal(true);
                         if (e.key === 'Backspace') executeDelete(item, template, setTemplate);
                     }}>
                    <span className="color" style={{ background: item.color }}/>
                    <p className="name">{item.name}</p>
                </div>
            </div>
        </>
    );
}

export default TemplateLegendItemElement;
